import React from "react";
import LegalPage from "./LegalPage";

export default function ShippingPage() {
  return (
    <LegalPage
      eyebrow="Policy · House Rules"
      title="Shipping|Info."
      updated="February 2026"
      summary="Free US ground shipping on every order. We pack, print, and ship from Los Angeles, usually within 24 hours of your payment clearing. Here's exactly what to expect."
      sections={[
        {
          id: "areas",
          heading: "Where we ship",
          body: [
            "We currently ship to all 50 U.S. states, Washington D.C., and Puerto Rico. Free ground shipping applies to every order - no minimums, no surprises at checkout.",
            "International shipping (Canada, UK, Australia, EU) is calculated live at checkout via Easyship. Duties and taxes are the buyer's responsibility unless otherwise noted at checkout.",
          ],
        },
        {
          id: "timing",
          heading: "Processing & delivery times",
          body: [
            "Orders placed before 2pm PT on a business day ship the same day. Orders after 2pm ship next business day. We do not ship on weekends or U.S. federal holidays.",
            [
              "Standard US Ground · 3–5 business days after ship date",
              "Expedited (2-Day) · Available at checkout - rates shown live",
              "International · 6–14 business days depending on destination",
            ],
            "Delivery times exclude the 1 business day we take to pack your order.",
          ],
        },
        {
          id: "tracking",
          heading: "Tracking your order",
          body: [
            "You'll receive a shipping confirmation email with your tracking number the moment your box leaves our fulfilment center.",
            "You can also track any order from our Track Order page using the email you used at checkout plus your order ID (sent in the payment confirmation).",
          ],
        },
        {
          id: "issues",
          heading: "Lost, delayed, or damaged packages",
          body: [
            "If your tracking hasn't updated in 5+ business days, or your box arrives damaged, reply to your order confirmation email within 14 days of delivery. We'll replace or refund it - no drama.",
          ],
        },
      ]}
      related={[
        { label: "Returns Policy", to: "/returns" },
        { label: "Track Order", to: "/orders/track" },
        { label: "Terms & Conditions", to: "/terms" },
      ]}
    />
  );
}
